var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var FollowIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 64,
    glyphHeight: 61,
    glyphOffsetY: 3
  }), React.createElement("path", {
    d: "M32 33.4622C35.4578 33.4622 38.2609 30.6591 38.2609 27.2013C38.2609 23.7435 35.4578 20.9404 32 20.9404C28.5422 20.9404 25.7391 23.7435 25.7391 27.2013C25.7391 30.6591 28.5422 33.4622 32 33.4622Z"
  }), React.createElement("path", {
    d: "M59.7565 10.2963C55.3739 3.61801 47.6521 0.0701851 39.9304 1.11366C37.0086 1.53105 34.2956 2.57453 31.7912 4.0354C29.2869 2.57453 26.5739 1.53105 23.6521 1.11366C15.9304 0.0701851 8.20864 3.61801 3.82603 10.2963C-1.18266 18.018 -0.765272 28.0354 5.2869 37.8441C11.9652 48.905 22.3999 55.1658 31.7912 60.8006C40.9739 55.1658 51.4086 48.6963 58.2956 37.8441C64.3478 28.0354 64.9739 18.018 59.7565 10.2963ZM51.4086 33.2528C46.6086 40.9745 39.3043 46.4006 31.9999 50.7832C24.6956 46.1919 17.3912 40.9745 12.5912 33.2528C8.41734 26.3658 7.79125 19.6876 11.1304 14.6789C13.6347 10.7137 18.226 8.62671 22.8173 9.2528C26.3652 9.67019 29.4956 11.7571 31.9999 15.0963C34.5043 11.7571 37.6347 9.67019 41.1826 9.2528C45.7739 8.62671 50.1565 10.7137 52.8695 14.6789C55.9999 19.6876 55.5826 26.5745 51.4086 33.2528Z"
  }));
};
export var FollowIconGlyph = function (props) {
  return React.createElement(FollowIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};